import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaHidden", "ariaLabel", "children", "color", "disabled", "variant"];
import React, { cloneElement, Children, forwardRef } from 'react';
import { alpha, darken, IconButton, useTheme } from '@mui/material';
import { useThemeColor } from '../../../themes/hooks/useThemeColor';
var EzIconButtonMui = forwardRef(function (_ref, ref) {
  var ariaHidden = _ref.ariaHidden,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    color = _ref.color,
    disabled = _ref.disabled,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var isCommonColor = color === null || color === void 0 ? void 0 : color.startsWith('common.');
  var themeColor = useThemeColor(disabled ? 'common.disabled' : color);
  var outlineBoxShadow = "inset 0 0 0 2px ".concat(themeColor);
  var Child = Children.only(children);
  var iconColor = variant === 'filled' ? 'common.white' : disabled ? 'common.disabled' : color;
  return React.createElement(IconButton, _extends({
    ref: ref,
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    classes: {
      root: "EzIconButton EzIconButton-".concat(variant),
      disabled: 'EzIconButton-disabled'
    },
    color: isCommonColor ? undefined : color,
    disabled: disabled,
    sx: {
      bgcolor: variant === 'filled' ? themeColor : undefined,
      boxShadow: variant === 'outlined' ? outlineBoxShadow : undefined,
      '&:focus': {
        outline: "2px solid ".concat(theme.palette.common.black),
        outlineOffset: '2px'
      },
      '&:hover, &:active': {
        bgcolor: variant === 'filled' ? darken(themeColor, 0.2) : alpha(themeColor, 0.1),
        borderColor: variant !== 'basic' ? themeColor : undefined
      }
    }
  }, props), cloneElement(Child, {
    color: Child.props.color === 'inherit' || Child.props.color == null ? iconColor : Child.props.color
  }));
});
EzIconButtonMui.displayName = 'EzIconButtonMui';
export default EzIconButtonMui;